import { SavingsProduct } from "@/dto/savings/Savings";
import {
  Box,
  Button,
  Drawer,
  Flex,
  Group,
  ScrollArea,
  Space,
  Text,
} from "@mantine/core";
import savingCardBg from "../assets/saving-card-bg.jpg";
import { useTranslation } from "react-i18next";
import { beText } from "@/utils/beText";

interface Props {
  opened: boolean;
  close: () => void;
  data?: SavingsProduct;
  onSubmit?: () => void;
}
const SavingDetailDrawer = ({ opened, close, data, onSubmit }: Props) => {
  const { t } = useTranslation();
  console.log("data", data);
  return (
    <Drawer
      opened={opened}
      onClose={close}
      title={t("GENERAL_DETAIL")}
      position="right"
      size={678}
      withCloseButton
      styles={{
        header: { borderBottom: "1px solid #F0F2F7" },
        title: {
          fontWeight: 600,
        },
      }}
    >
      {/* Drawer content */}
      <Space h={20} />

      <Flex
        sx={{
          overflow: "hidden",
          borderRadius: "16px",
          background: `linear-gradient(86.29deg, rgba(26, 149, 232, 0.75) -5.13%, rgba(118, 205, 232, 0.75) 84.17%), url(${savingCardBg})`,
          backgroundSize: "cover",
          height: 220,
        }}
        align="center"
      >
        <Box sx={{ flex: 1, minWidth: 0 }} px={24} py={20}>
          <Text fw={700} fz={18} c="#fff" mb={8}>
            {beText(data?.title)}
          </Text>
          <Text fz={13} c="#fff" lh={1.5} sx={{ opacity: 0.9 }}>
            {beText(data?.desc)}
          </Text>
        </Box>
        <Box
          sx={{
            flex: "0 0 45%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={data?.image}
            alt={data?.title}
            style={{
              maxHeight: "100%",
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Flex>
      <Space h={20} />
      <ScrollArea
        style={{ height: "58vh", fontSize: "14px", lineHeight: "27px" }}
        px={10}
      >
        <div dangerouslySetInnerHTML={{ __html: data?.content || "" }} />
      </ScrollArea>
      <Group
        style={{
          position: "fixed",
          bottom: 0,
          width: "96%",
          borderTop: "1px solid #F0F2F7",
        }}
        p={20}
        position="right"
      >
        <Button
          variant="outline"
          sx={{
            borderRadius: "12px",
            color: "#000",
            borderColor: "#E4E7EC",
            backgroundColor: "#E4E7EC",
            "&:hover": { backgroundColor: "#D0D5DD" },
          }}
          onClick={close}
        >
          {t("CLOSE")}
        </Button>
        <Button sx={{ borderRadius: "12px" }} onClick={onSubmit}>
          {t("REGISTER")}
        </Button>
      </Group>
    </Drawer>
  );
};
export default SavingDetailDrawer;
